import React, { PureComponent } from 'react';
import MessageCard from '../../components/Cards/MessageCard.js';
import Classes from './Classes.js';
import Divisions from './Divisions.js';
import Loader from '../../components/Loader.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class ClassesDivisions extends PureComponent {
  _getMessageCard = () => {
    if ((this.props.isMasterSite || this.props.currentAccountMeta.isPrivateLabel) && this.props.currentAccountMeta.status === 1) {
      return null;
    }
    if (this.props.isMasterSite && (this.props.isQuote || this.props.isRevision)) {
      if (this.props.step <= 3) {
        return /*#__PURE__*/React.createElement(MessageCard, {
          title: i18n.t(tokens.titles.classesAndDivisions),
          subtitle: `${i18n.t(tokens.labels.classesAndDivisions.managementHeader)} ${this.props.isRevision ? i18n.t(tokens.labels.quotes.revision) : i18n.t(tokens.labels.quotes.quote)} ${i18n.t(tokens.labels.classesAndDivisions.managementNote)}`
        });
      }
      if (this.props.isQuote) {
        return /*#__PURE__*/React.createElement(MessageCard, {
          title: i18n.t(tokens.titles.classesAndDivisions),
          subtitle: i18n.t(tokens.labels.classesAndDivisions.pricingNote),
          btn: true,
          btnName: i18n.t(tokens.buttons.setQuoteBack),
          btnOnClick: () => this.props.setState(2)
        });
      }
      return null;
    }
    if (this.props.step <= 3) {
      return /*#__PURE__*/React.createElement(MessageCard, {
        title: i18n.t(tokens.titles.classesAndDivisions),
        subtitle: i18n.t(tokens.labels.classesAndDivisions.managementNoteDivision)
      });
    }
    return /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.classesAndDivisions),
      subtitle: i18n.t(tokens.labels.classesAndDivisions.reviewNote)
    });
  };
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this._getMessageCard(), /*#__PURE__*/React.createElement(Classes, {
      classData: this.props.classData,
      editClass: this.props.editClass,
      addClass: this.props.addClass,
      removeClass: this.props.removeClass,
      isQuote: this.props.isQuote,
      isRevision: this.props.isRevision,
      step: this.props.step,
      isMasterSite: this.props.isMasterSite,
      loader: this.props.loader,
      whitelabel: this.props.whitelabel,
      currentAccountMeta: this.props.currentAccountMeta,
      language: this.props.language || "en"
    }), /*#__PURE__*/React.createElement(Divisions, {
      divisions: this.props.divisions,
      editDivision: this.props.editDivision,
      addDivision: this.props.addDivision,
      removeDivision: this.props.removeDivision,
      validateBankingDetails: this.props.validateBankingDetails,
      bankingDetailsVerifying: this.props.bankingDetailsVerifying,
      isQuote: this.props.isQuote,
      isRevision: this.props.isRevision,
      step: this.props.step,
      isMasterSite: this.props.isMasterSite,
      loader: this.props.loader,
      whitelabel: this.props.whitelabel,
      currentAccountMeta: this.props.currentAccountMeta,
      language: this.props.language || "en"
    }), this.props.loader?.isLoading && this.props.loader.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    }));
  }
}
export default ClassesDivisions;